import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../base/input.component';
import { AltNeu } from '../../core/types';
import { TextViewComponent } from './text-view.component';

@Component({
    standalone: true,
    imports: [CommonModule, TextViewComponent],
    selector: 'wd-an-text',
    templateUrl: 'alt-neu-text-view.component.html',
    styleUrls: ['../styles/view-only.component.css', '../styles/view.component.css'],
})
export class AltNeuTextViewComponent extends InputComponent<AltNeu<string>> {
	@Input() horizontal = true;

	constructor() {
		super();
	}
}
